<template>
	<mdb-select :btn-save="false" :options="options" @change="select" v-model="type" :disabled="disabled">
		<option value="Entity">{{ $t('rules.fields.entity', locale) }}</option>
		<option value="Function">{{ $t('rules.fields.function', locale) }}</option>
		<option value="Aggregate">{{ $t('rules.fields.aggregate', locale) }}</option>
	</mdb-select>
</template>

<script>
import { mdbSelect } from '@/components/mdbvue'
import { mapState } from 'vuex'

export default {
	name: 'TypeSelect',
	components: { mdbSelect },
	props: {
		disabled: {
			type: Boolean,
			default: false
		},
		value: {
			type: String,
			default: 'Entity'
		}
	},
	emits: [ 'input' ],
	computed: {
		typeOptions () {
			return [{ text: this.$t('rules.fields.type-select', this.locale), value: null, disabled: true, selected: !this.definition }]
				.concat(Object.values(this.usedDefinitions).map((d) => ({ text: d.label, value: d.name, selected: this.definition && (this.definition.name === d.name) })))
		},
		type: {
			get () { return this.value },
			set (value) { this.$emit('input', value) }
		},
		...mapState(['locale'])
	}
}
</script>

<style scoped>

</style>
